<div class="app-container" cdkScrollable>
  <div class="app-content">
    <div class="app-scroll-content" name="app-scroll">
      <div class="container container-side-nav">
        <mat-sidenav-container (backdropClick)="sidenavService.close()">
          <mat-sidenav
            #sidenav
            [disableClose]="disableClose"
            [mode]="sidenavService.mode"
            [opened]="sidenavService.opened"
            [fixedInViewport]="true">

              <div class="sidenav-container">

                <div class="logo">
                  <a class="image" [routerLink]="logoLink">
                    <app-logo type="light" width="100"></app-logo>
                  </a>
                </div>

                <fs-sidenav
                  #sideNavMainEl
                  [config]="sideNavMain">
                </fs-sidenav>

                <div class="spacer"></div>

                <fs-sidenav
                  #sideNavExperienceEl
                  [config]="sideNavExperience">
                </fs-sidenav>
              </div>

          </mat-sidenav>
          <mat-sidenav-content>
            <app-top-bar
              [account]="account"
              [unreadCount]="unreadCount()"></app-top-bar>
            <navbar></navbar>
            <div class="main-container">
              <router-outlet></router-outlet>
            </div>
          </mat-sidenav-content>
        </mat-sidenav-container>

        <!-- Rendered by fs-sidenav after the item's label (TU-T9400). -->
        <ng-template #communicationsCount>
          @if (unreadCount()) {
            <div class="count">{{ unreadCount() }}</div>
          }
        </ng-template>
      </div>
    </div>
  </div>
</div>
